"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _Image = _interopRequireDefault(require("../atoms/Image"));
var _Column = _interopRequireDefault(require("../layout/Column"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  images: [],
  isItOnOverlay: false,
  fit: 'contain',
  alt: '',
  fallbackImage: '',
  slideImageSize: 30,
  containerStyles: '',
  className: '',
  onExpandImage() {},
  onChangeImage() {}
};
function ImagesGallery(props) {
  const {
    alt,
    fit,
    images,
    defaultImage,
    fallbackImage,
    mainImageWidth,
    mainImageHeight,
    slideImageSize,
    isItOnOverlay,
    containerStyles,
    className,
    onExpandImage,
    onChangeImage
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [currentImage, setCurrentImage] = (0, _react.useState)();
  const {
    colors
  } = (0, _react2.useTheme)();
  const color = (0, _react.useMemo)(() => isItOnOverlay ? colors.NEUTRAL.BACKGROUND : colors.FONT.DESCRIPTION, [isItOnOverlay, colors]);
  const onChange = (0, _react.useCallback)(image => {
    setCurrentImage(image);
    onChangeImage === null || onChangeImage === void 0 || onChangeImage(image);
  }, [onChangeImage]);
  (0, _react.useEffect)(() => {
    setCurrentImage(defaultImage);
  }, [defaultImage]);
  if (!Boolean(images === null || images === void 0 ? void 0 : images.length)) {
    return /*#__PURE__*/_react.default.createElement(NoImageContainer, {
      onClick: onExpandImage,
      height: mainImageHeight,
      "data-role": "galley-insert-photo",
      className: className,
      children: /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "insert_photo",
        size: 40,
        color: color
      })
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 15,
    align: "center",
    styles: containerStyles,
    className: className
  }, /*#__PURE__*/_react.default.createElement(MainImageFigure, {
    mainImageHeight: mainImageHeight,
    mainImageWidth: mainImageWidth,
    "data-main-image": "true"
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: currentImage === null || currentImage === void 0 ? void 0 : currentImage.value,
    alt: alt,
    width: "100%",
    height: "100%",
    fallback: fallbackImage,
    onClick: onExpandImage,
    fit: fit,
    datasets: {
      id: currentImage === null || currentImage === void 0 ? void 0 : currentImage.id
    }
  })), /*#__PURE__*/_react.default.createElement(Carousel, {
    "data-image-carousel": "true"
  }, images === null || images === void 0 ? void 0 : images.map(_ref => {
    let {
      value,
      id
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(_Image.default, {
      width: slideImageSize,
      height: slideImageSize,
      fallback: fallbackImage,
      src: value,
      alt: "".concat(alt, " - ").concat(id),
      key: id,
      fit: "contain",
      onClick: () => onChange({
        value,
        id
      }),
      backgroundColor: (currentImage === null || currentImage === void 0 ? void 0 : currentImage.value) === value ? colors.NEUTRAL.SIDE : colors.NEUTRAL.TRANSPARENT
    });
  })));
}
const NoImageContainer = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  cursor: pointer;\n  height: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  justify-self: center;\n"])), _ref2 => {
  let {
    height
  } = _ref2;
  return typeof height === 'number' ? "".concat(height, "px") : height;
});
const MainImageFigure = _styled.default.figure(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 10px;\n  overflow: hidden;\n  ", "\n"])), _ref3 => {
  let {
    mainImageHeight,
    mainImageWidth
  } = _ref3;
  return "\n    width: ".concat(mainImageWidth, ";\n    height: ").concat(mainImageHeight, ";\n  ");
});
const Carousel = _styled.default.figure(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  justify-content: center;\n"])));
var _default = exports.default = ImagesGallery;